import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';

const SummaryContainer = (_param)=> {
    var { children , className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "children",
        "className"
    ]);
    return React.createElement("article", swcHelpers.extends({
        className: classnames('summary__container', className)
    }, rest), children);
};
var SummaryContainer$1 = SummaryContainer;

export { SummaryContainer$1 as default };
//# sourceMappingURL=SummaryContainer.js.map
